import { Component, OnInit, Input } from '@angular/core';
import { IContribuyente } from 'src/app/core/models/worker/iworker-information';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { IUser } from 'src/app/core/models/user/user';
import { environment } from 'src/environments/environment';
import { CompanyService } from 'src/app/core/services/company/company.service';
import { InformationFormatting } from 'src/app/core/helpers/information-formatting/information-formatting';

@Component({
  selector: 'app-affiliations',
  templateUrl: './affiliations.component.html',
  styleUrls: ['./affiliations.component.scss']
})
export class AffiliationsComponent implements OnInit {
  @Input() titleSite: string;
  numAffiliates = 0;
  companyData: IContribuyente;
  userloggedin:IUser;
  constructor(private _STORAGE: LocalStorageService,
              private companyService: CompanyService) { }

  ngOnInit() {
    this.userloggedin = this._STORAGE.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this.companyData = this._STORAGE.getItemJSON(environment.LOCAL_STORAGE.BUSINESS_INFORMATION);
    if (this.companyData === undefined || this.companyData === null) {
      this.fillCompanyData();
    } else {
      this.fillNumAffiliates();
    }
  }

  fillCompanyData(){
    this.companyService.getBusinnessInformation(InformationFormatting.returnNameDocumentCompany(this.userloggedin.docTypeCompany),
    this.userloggedin.docNumberCompany,
    this.userloggedin.checkDigit).subscribe(res=>{
      this.companyData = res.body.data[0].contribuyente
      this.fillNumAffiliates();
    });
  }

  fillNumAffiliates(){
    this.companyData.detalleAportantes.forEach((val=>{
      this.numAffiliates += val.numeroCotizantes;
    }));
  }

}
